import React from "react";
import FaqsComp from "../FaqsComp";
import classes from "./ServiceWhyChooseSection.module.css";
import { Link } from "react-router-dom";

export default function ServiceWhyChooseSection({
  imageSrc,
  imageAlt = "Why choose this service",
  title = "Hire a Dedicated Medical Billing Consultant",
  description = "",
  btnText = "Contact Us",
  question = [],
  answer = [],
}) {
  return (
    <section className={classes.section}>
      <div className={`container ${classes.shell}`}>
        <div className={classes.mediaColumn}>
          <div className={classes.imageCard}>
            <img className={classes.image} src={imageSrc} alt={imageAlt} />
          </div>
        </div>

        <div className={classes.contentColumn}>
          <h2>{title}</h2>
          <p>{description}</p>
          <Link to="/contact-us" className={classes.ctaButton}>
            {btnText}
          </Link>
          <FaqsComp question={question} answer={answer} />
        </div>
      </div>
    </section>
  );
}
